module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5615aa7220494ca18b0b3371956d153a.png";